export const FormHeader = ({
  textTitle,
  onBackClick,
  onDownloadClick,
  userRole,
  orderType,
  regenerateChatGPTText,
  regenerateLoading,
}) => {
  return (
    <div className="box-header-top header-info">
      <span className="back-icon me-3" onClick={onBackClick} role="button" aria-label="Retour" />
    </div>
  );
};
